import embed from "embed-video";
import capitalize from "lodash/capitalize";
import React from "react";
import { withTranslation } from "react-i18next";
import { S3_CDN_DOMAIN } from "../../constants";
import { getYoutubeVideoId } from "../../utils/exercise-video-preview";
import Modal from "../modal-new";

class ExerciseLibraryVideoModal extends React.Component {
  render() {
    const { exercise, primary: primaryProp, t } = this.props;
    const videoOriginal = this.props.exercise.video.videoOriginal?.replace(
      /\.[^/.]+$/,
      ".mp4"
    );
    const url = `${S3_CDN_DOMAIN}other_exercise_videos/${this.props.athleteId}/${videoOriginal}`;
    const youtubeVideo = getYoutubeVideoId(exercise.video.url);

    const primaryMovements = [
      "Deadlift",
      "Squat",
      "Bench",
      "Clean",
      "Jerk",
      "Snatch",
      "OverheadPress",
    ];
    const isPrimary =
      exercise.movement && primaryMovements.includes(exercise.movement);
    const primary = exercise.primary || primaryProp;
    let title =
      primary === "assistant" || isPrimary
        ? exercise.movement
        : `${exercise.movement} (${capitalize(primary)})`;
    if (exercise.name) {
      title = exercise.name;
    }

    return (
      <Modal className="one-video-modal" toClear={["exercise"]} title={title}>
        <div className="body">
          {exercise.video?.url ? (
            <>
              <div className="mb-6">
                <label htmlFor="url-input">
                  {t("exerciseLibraryVideoModal.exerciseUrl")}
                </label>
                <input
                  type="text"
                  className="url-input"
                  value={exercise.video.url}
                  readOnly="readonly"
                  id="url-input"
                />
              </div>
              <div className="exercise-library-video-iframe">
                <div
                  className="embed-video-wrapper"
                  dangerouslySetInnerHTML={{
                    __html: youtubeVideo
                      ? embed.youtube(youtubeVideo, {
                          attr: { width: "100%", height: 478 },
                        })
                      : embed(exercise.video.url, {
                          attr: { width: "100%", height: 478 },
                        }),
                  }}
                />
              </div>
            </>
          ) : (
            <>
              <a
                href={url}
                target="_blank"
                download="download"
                role="button"
                data-button-type="secondary"
                data-icon-only
                data-icon
                title={t("exerciseLibraryVideoModal.downloadVideo")}
              >
                <img
                  className="download-video-icon"
                  src="/img/icon-download.webp"
                  alt={t("exerciseLibraryVideoModal.downloadVideo")}
                />
              </a>

              <div className="exercise-library-video-iframe">
                <video
                  width="100%"
                  height="478"
                  controls
                  controlsList="nodownload"
                  disablePictureInPicture
                  src={url}
                />
              </div>
            </>
          )}
        </div>
      </Modal>
    );
  }
}

export default withTranslation("coaching-portal")(ExerciseLibraryVideoModal);
